import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import Breadcrumb from "CommonComponents/breadcrumb";

import {
  Awesome,
  EditPanel,
  Spinner,
} from "CommonComponents/bricks";
import createEigenschaftenEditor, {
  createEigenschaftenEditorWithPosition,
} from "App/mn-editors"; // TH: hier mn-editors (fork von mn-context)
import {
  istArtTarifvertrag,
  istTypWerkvertrag,
  VERTRAGSARTEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
} from "App/constants";
import {
  togglePlugin,
} from "App/plugins";
import {
  ArbeitszeitRenderMethods,
  DeputatRenderMethods,
  LehrauftragRenderMethods,
  massnahmevorgesehenApi,
  QualizielRenderMethods,
  schemaArbeitszeitMn,
  schemaDeputatMn,
  schemaLehrauftragMn,
  schemaMassnahme,
  schemaQualizielMn,
  schemaTaetigkeitMn,
  TaetigkeitRenderMethods,
} from "Apis/massnahme-api";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import {
  generateAbDateField,
} from "App/mn-detail-page";

const Taetigkeit = createEigenschaftenEditor([schemaTaetigkeitMn], TaetigkeitRenderMethods, [massnahmevorgesehenApi.current], { property: "massnahmetaetigkeit", id: "mt_id" });
const actionTaetigkeit = {
  buttonUpName: "Tätigkeit bearbeiten",
  extraClass: "tatigkeit",
};

const Qualiziel = createEigenschaftenEditor([schemaQualizielMn], QualizielRenderMethods, [massnahmevorgesehenApi.current], { property: "massnahmequaliziel", id: "mq_id" });
const actionQualiziel = {
  buttonUpName: "Qualifikationen bearbeiten",
  extraClass: "tatigkeit",
};

const Lehrauftrag = createEigenschaftenEditor([schemaLehrauftragMn], LehrauftragRenderMethods, [massnahmevorgesehenApi.current], { property: "massnahmelehrauftrag", id: "ml_id" });
const actionLehrauftrag = {
  buttonUpName: "Lehrauftrag bearbeiten",
  extraClass: "tatigkeit",
};


const Arbeitszeit = createEigenschaftenEditorWithPosition([schemaArbeitszeitMn], ArbeitszeitRenderMethods, [massnahmevorgesehenApi.current], { property: "massnahmepaz", id: "mp_id" });
const actionArbeitszeit = {
  buttonUpStyle: "link",
  buttonUpName: <Awesome name='close' />,
};

const Deputat = createEigenschaftenEditorWithPosition([schemaDeputatMn], DeputatRenderMethods, [massnahmevorgesehenApi.current], { property: "massnahmedeputat", id: "md_id" });
const actionDeputat = {
  buttonUpStyle: "link",
  buttonUpName: <Awesome name='close' />,
};

const injects = [
  ...injectsFromSchemaAndRenderMethods(schemaMassnahme),
];

const selectInjects = createInjectsSelector(injects);

@store(...injects, "user")
@massnahmevorgesehenApi.current
export default class MnVorgesehenDetailPage extends Component {
  constructor() {
    super();
  }

  get entityVertragsdaten() {
    const { currentMassnahmevorgesehen } = this.props;
    if (currentMassnahmevorgesehen) {
      const clone = _.clone(currentMassnahmevorgesehen);
      clone.massnahmelehrauftrag = [this.entityLehrauftrag];
      return clone;
    }
    return null;
  }

  get entityLehrauftrag() {
    const { currentMassnahmevorgesehen } = this.props;
    let entity = {};
    if (currentMassnahmevorgesehen) {
      entity = _.clone(currentMassnahmevorgesehen);
    }
    entity = _.pickBy(entity, (value, key) => key.startsWith("ml"));
    return entity;
  }

  render() {
    const {
      currentMassnahmevorgesehen,
    } = this.props;

    if (!currentMassnahmevorgesehen) {
      return <Spinner />;
    }


    const { entityVertragsdaten } = this;

    const istWerkvertrag = istTypWerkvertrag(entityVertragsdaten.m_katid);
    const istTarif = istArtTarifvertrag(entityVertragsdaten.m_artid);
    const istLehrauftrag = VERTRAGSARTEN_LEHRAUFTRAG.indexOf(entityVertragsdaten.m_artid) >= 0;

    const args = {
      istLehrauftrag,
      istWerkvertrag,
      istTarif,
      istWiss: !!(istTarif && entityVertragsdaten.massnahmetarif?.length && entityVertragsdaten.massnahmetarif[0].mtf_ist_wiss),
      istWHK: entityVertragsdaten && entityVertragsdaten.m_artid == VERTRAGSARTEN.WHK,
    };


    return <div>
      <Breadcrumb data={[
        { name: "Vorgesehene Maßnahmen", path: "/massnahmevorgesehen" },
        { name: currentMassnahmevorgesehen && currentMassnahmevorgesehen.m_bez || "Neue Maßnahme" },
      ]} />

      <div className='detail-form bordered'>
        <EditPanel
          header={<h4 key='h4'>Allgemeine Vertragsdaten</h4>}
          editable={false}
          schema={schemaMassnahme}
          injects={_.assign(selectInjects(this.props), { getEntity: entityVertragsdaten, istTarif })}
          customControls={{ abdate: generateAbDateField }}
          entity={entityVertragsdaten}
        />
        {togglePlugin("arbeitszeit", args) && <span>
          <Arbeitszeit
            readonly
            additionalInjects={entityVertragsdaten}
            panelName='Arbeitszeit'
            panelNameNew='Neue Arbeitszeit hinzufügen'
            panelNamePosition='Arbeitszeit bearbeiten'
            action={actionArbeitszeit}
            typUniqueField='mp_id'
            parentEntity={entityVertragsdaten}
          />
          {togglePlugin("tätigkeit", args) && <Taetigkeit
            readonly
            panelName='Tätigkeit'
            action={actionTaetigkeit}
            typField='mne_metid'
            parentEntity={entityVertragsdaten}
          />}
        </span>}
        {entityVertragsdaten && togglePlugin("qualiziele", args) &&
          <Qualiziel
            readonly
            panelName='Qualifikationen'
            action={actionQualiziel}
            typField='mne_metid'
            parentEntity={entityVertragsdaten}
          />
        }
        {this.entityLehrauftrag && istLehrauftrag &&
        <Lehrauftrag
          readonly
          panelName='Lehrauftrag'
          action={actionLehrauftrag}
          typField='mne_metid'
          parentEntity={entityVertragsdaten}
        />
        }
        {entityVertragsdaten && togglePlugin("deputat", args) && <Deputat
          readonly
          panelName='Deputat'
          panelNameNew='Neues Deputat hinzufügen'
          panelNamePosition='Deputat bearbeiten'
          action={actionDeputat}
          typUniqueField='md_id'
          parentEntity={entityVertragsdaten}
        />}
      </div>
    </div>;
  }
}

/*
 *undefined
 *undefined
 */
